export type TicketStatus = 'OPEN' | 'IN_PROGRESS' | 'WAITING' | 'RESOLVED' | 'CLOSED';

export type TicketPriority = 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT';

export type TicketMessageType = 'MESSAGE' | 'INTERNAL_NOTE' | 'SYSTEM';

export type TicketActivityAction =
    | 'TICKET_CREATED'
    | 'ASSIGNEE_ADDED'
    | 'ASSIGNEE_REMOVED'
    | 'STATUS_CHANGED'
    | 'PRIORITY_CHANGED'
    | 'CATEGORY_CHANGED'
    | 'DUE_DATE_CHANGED'
    | 'ATTACHMENT_ADDED'
    | 'MESSAGE_ADDED'
    | 'TICKET_RESOLVED'
    | 'TICKET_REOPENED'
    | 'TICKET_CLOSED';

export interface InternalSupportUser {
    _id: string;
    name: string;
    username?: string;
    dpUrl?: string;
}

export interface TicketAttachment {
    name: string;
    url: string;
    mimeType?: string;
    size?: number;
}

export interface InternalSupportTicket {
    _id: string;
    ticketId: string;
    title: string;
    description?: string;
    status: TicketStatus;
    priority: TicketPriority;
    reseller: string;
    createdBy: InternalSupportUser;
    assignees: InternalSupportUser[];
    attachments: TicketAttachment[];
    category?: string;
    tags?: string[];
    dueDate?: string;
    closedAt?: string;
    closedBy?: InternalSupportUser;
    createdAt: string;
    updatedAt: string;
}

export interface InternalSupportMessage {
    _id: string;
    ticket: string;
    sender: InternalSupportUser;
    message: string;
    attachments: TicketAttachment[];
    type: TicketMessageType;
    replyTo?: string;
    mentions?: InternalSupportUser[];
    editedAt?: string;
    deletedAt?: string;
    createdAt: string;
    updatedAt: string;
}

export interface InternalSupportActivity {
    _id: string;
    ticket: string;
    performedBy?: InternalSupportUser;
    action: TicketActivityAction;
    data?: {
        oldValue?: string;
        newValue?: string;
    };
    createdAt: string;
}

export interface InternalSupportTicketListParams {
    status?: TicketStatus;
    priority?: TicketPriority;
    assignedToMe?: boolean;
    unassigned?: boolean;
    search?: string;
}

export interface CreateInternalSupportTicketPayload {
    title: string;
    description?: string;
    status?: TicketStatus;
    priority: TicketPriority;
    category?: string;
    tags?: string[];
    assignees?: string[];
    dueDate?: string;
    attachments?: TicketAttachment[];
    attachmentFiles?: File[];
}

export interface UpdateInternalSupportTicketPayload {
    title?: string;
    description?: string;
    status?: TicketStatus;
    priority?: TicketPriority;
    assignees?: string[];
    category?: string;
    tags?: string[];
    dueDate?: string;
}

export interface CreateInternalSupportMessagePayload {
    message?: string;
    type: TicketMessageType;
    replyTo?: string;
    mentions?: string[];
    attachments?: TicketAttachment[];
    attachmentFiles?: File[];
}

export interface InternalSupportTicketListResponse {
    tickets: InternalSupportTicket[];
    total: number;
}

export interface InternalSupportMessageListResponse {
    messages: InternalSupportMessage[];
    total: number;
}

export interface InternalSupportActivityListResponse {
    activities: InternalSupportActivity[];
    total: number;
}

export const ticketStatuses: TicketStatus[] = ['OPEN', 'IN_PROGRESS', 'WAITING', 'RESOLVED', 'CLOSED'];
export const ticketPriorities: TicketPriority[] = ['LOW', 'MEDIUM', 'HIGH', 'URGENT'];
